import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['year', 'month', 'dateButtonsContainerTemplate', 'dateButtonTemplate', 'dateButtons', 'dateField', 'modal'];

  static classes = ['placeholder', 'selected', 'unselected', 'today'];

  static values = { today: String };

  connect() {
    this.today = new Date();
    this.creteDateButtons(this.today.getFullYear(), this.today.getMonth() + 1);
  }

  openModal() {
    this.modalTarget.classList.remove('hidden');
  }

  closeModal() {
    this.modalTarget.classList.add('hidden');
  }

  globalClickHandler(e) {
    if (!this.element.contains(e.target)) {
      this.closeModal();
    }
  }

  changeHandler() {
    this.creteDateButtons(this.yearTarget.value, this.monthTarget.value);
  }

  nextHandler() {
    const nextDate = new Date(this.yearTarget.value, this.monthTarget.value);
    this.setMonthSelect(nextDate);
  }

  previousHandler() {
    const previousDate = new Date(this.yearTarget.value, this.monthTarget.value - 2);
    this.setMonthSelect(previousDate);
  }

  dateClickHandler(e) {
    const clickedDate = e.currentTarget.dataset.date;
    if (!clickedDate) return;

    const nextDate = new Date(this.yearTarget.value, this.monthTarget.value - 1, clickedDate);
    this.dateFieldTarget.value = this.constructor.formatDate(nextDate);
    this.dateFieldTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.creteDateButtons(nextDate.getFullYear(), nextDate.getMonth() + 1);
  }

  setMonthSelect(date) {
    this.yearTarget.value = date.getFullYear();
    this.monthTarget.value = date.getMonth() + 1;
    this.yearTarget.dispatchEvent(new Event('change', { bubbles: true }));
    this.monthTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  creteDateButtons(year, month) {
    const datePerWeek = this.constructor.getDatePerWeek(year, month);
    const currentSelectedDate = new Date(this.dateFieldTarget.value);

    this.dateButtonsTarget.innerHTML = null;
    datePerWeek.forEach((dateArray) => {
      const dateContainer = this.dateButtonsContainerTemplateTarget.cloneNode(true);
      dateContainer.classList.remove('hidden');

      for (let i = 0; i < dateArray.length; i += 1) {
        const newDateButton = this.dateButtonTemplateTarget.cloneNode(true);
        newDateButton.classList.remove('hidden');

        if (dateArray[i]) {
          newDateButton.dataset.date = dateArray[i].getDate();
          newDateButton.innerHTML = this.constructor.toTwoDigit(dateArray[i].getDate());
          if (currentSelectedDate.toDateString() === dateArray[i].toDateString()) {
            this.assignSelectedClasses(newDateButton);
          } else if (this.today.toDateString() === dateArray[i].toDateString()) {
            this.assignTodayClasses(newDateButton);
          }
        } else {
          newDateButton.dataset.date = '';
          newDateButton.innerHTML = '';
          newDateButton.classList.add('pointer-events-none');
        }

        dateContainer.appendChild(newDateButton);
      }
      this.dateButtonsTarget.appendChild(dateContainer);
    });
  }

  assignSelectedClasses(dom) {
    this.unselectedClasses.forEach((cl) => dom.classList.remove(cl));
    this.selectedClasses.forEach((cl) => dom.classList.add(cl));
  }

  assignTodayClasses(dom) {
    this.todayClasses.forEach((cl) => dom.classList.add(cl));
  }

  static getDatePerWeek(year, month) {
    const beginningOfMonth = new Date(year, month - 1, 1);
    const endOfMonth = new Date(year, month, 0);

    const dateTable = Array(beginningOfMonth.getDay());
    for (let d = beginningOfMonth; d <= endOfMonth; d.setDate(d.getDate() + 1)) {
      dateTable.push(new Date(d));
    }

    const datePerWeek = [];
    for (let i = 0; i < dateTable.length; i += 7) {
      const dateWeek = dateTable.slice(i, i + 7);
      while (dateWeek.length < 7) dateWeek.push(null);
      datePerWeek.push(dateWeek);
    }

    return datePerWeek;
  }

  static formatDate(date) {
    return `${date.getFullYear()}/${this.toTwoDigit(date.getMonth() + 1)}/${this.toTwoDigit(date.getDate())}`;
  }

  static toTwoDigit(string) {
    if (string < 10) {
      return `0${string}`;
    }
    return string;
  }
}
